define('v3/Pages/WayOfWork/Services/WayOfWork.Backend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function WayOfWorkBackend () {
		BackendBase.call(this);
	}

	WayOfWorkBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(WayOfWorkBackend.prototype, {
		getAvailableSubjectCategories: function () {
			return this._getJsonApi('WayOfWork/AvailableSubjectCategories');
		},
		getStage: function (subjectCategory) {
			return this._getJsonApi('WayOfWork/Stage/' + subjectCategory);
		},
		getProgress: function (subjectCategory) {
			return this._getJsonApi('WayOfWork/Progress/' + subjectCategory);
		},
		getBoundaries: function (subjectCategory) {
			return this._getJsonApi('WayOfWork/Boundaries/' + subjectCategory);
		}
	});

	return new WayOfWorkBackend();
});
